import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import type { RootState } from "@/app/store/store";

import type { PersistPartial } from "redux-persist/es/persistReducer";

export const AuthenticatedRoute = () => {
	const isAuthenticated = useSelector(
		(
			state: RootState &
				PersistPartial & { auth: { isAuthenticated: boolean } },
		) => state.auth.isAuthenticated,
	);

	return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};
